import {Serializable, Serialize, SerializeProperty} from 'ts-serializer';

@Serialize({})
export class TorchPermissions extends Serializable {
  @SerializeProperty()
  effectiveRole: string;

  @SerializeProperty()
  effectiveDepartment: string;

  @SerializeProperty()
  effectiveEmployeeId: string;

  @SerializeProperty({
    list: true
  })
  accessibleEndpoints: string[];
}
